import { useState } from "react";
import api, { apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { toast } from "sonner";

export function DeleteEmployeesDialog({ employees, onClose, onDeleted }) {
  const [typed, setTyped] = useState("");
  const [busy, setBusy] = useState(false);
  const open = employees.length > 0;
  const close = () => { setTyped(""); onClose(); };
  const run = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/org/employees/delete", { ids: employees.map((e) => e.id), confirm: typed });
      toast.success(`${data.deleted} employee(s) deleted`);
      setTyped("");
      onDeleted();
    } catch (e) { toast.error(apiError(e.response?.data?.detail)); } finally { setBusy(false); }
  };
  return (
    <Dialog open={open} onOpenChange={(v) => !v && close()}>
      <DialogContent className="w-[calc(100%-2rem)] max-w-md" data-testid="delete-employees-dialog">
        <DialogHeader>
          <DialogTitle>Delete {employees.length === 1 ? employees[0].name || employees[0].email : `${employees.length} employees`}?</DialogTitle>
          <DialogDescription>They are removed from employee lists, forms and new rosters, and their login stops working for this organisation. Past payroll and approved rosters stay as they are.</DialogDescription>
        </DialogHeader>
        {employees.length > 1 && <p className="max-h-28 overflow-y-auto rounded bg-slate-50 p-2 text-xs text-slate-600">{employees.map((e) => e.name || e.email).join(", ")}</p>}
        <div><p className="mb-1 text-sm text-slate-700">Type <b>DELETE</b> to confirm</p>
          <Input value={typed} onChange={(e) => setTyped(e.target.value)} placeholder="DELETE" data-testid="delete-employees-confirm-input" /></div>
        <DialogFooter>
          <Button variant="outline" onClick={close} data-testid="delete-employees-cancel">Cancel</Button>
          <Button variant="destructive" disabled={typed !== "DELETE" || busy} onClick={run} data-testid="delete-employees-submit">{busy ? "Deleting…" : "Delete"}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
